<template>
  <div class="page-content--body">
    <div class="page-content--body-right">

      <div class="equipment-header">
        <v-tabs v-model="type" class="equipment-header--tabs stout--tabs">
          <v-tab href="#installation">Монтаж оборудования</v-tab>
          <v-tab href="#purchase">Покупка оборудования</v-tab>
        </v-tabs>
        <div class="equipment-header--add-buttons">
          <v-btn  class="btn-blue btn-small" color="primary">
            Добавить монтаж
          </v-btn>
          <v-btn  class="btn-blue btn-small" color="primary">
            Добавить покупку
          </v-btn>
        </div>
      </div>

        <v-card outlined class="equipment-body--table">
          <v-card-text class="equipment-body--header pb-0">
            <v-form
              autocomplete="off"
              lazy-validation
              ref="form"
              class="auth-form w-100"
            >
              <div class="auth-form--wrap d-flex flex-wrap ">
                <div class="auth-form--wrap-col">
                  <div class="input-label">Номер счёта</div>
                  <v-text-field
                    autofocus
                    class="field"
                    dense
                    outlined
                    type="text"
                  />
                </div>
                <div class="auth-form--wrap-col">
                  <div class="input-label">Дата создания</div>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted1"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      />
                    </template>
                    <v-date-picker
                      v-model="dateInstallation1"
                      :active-picker.sync="activePicker1"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      locale="ru-ru"
                      min="1950-01-01"
                      @change="SaveDate1"
                      first-day-of-week="1"
                      popover-direction="center"
                    />
                  </v-menu>
                </div>
                <div class="auth-form--wrap-col">
                  <div class="input-label">Дата обновления</div>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted2"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      />
                    </template>
                    <v-date-picker
                      v-model="dateInstallation2"
                      :active-picker.sync="activePicker2"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      locale="ru-ru"
                      min="1950-01-01"
                      @change="SaveDate2"
                      first-day-of-week="1"
                      popover="right"
                    />
                  </v-menu>
                </div>
                <v-spacer></v-spacer>
                <div class="equipment-body--header-right-fields">
                  <div class="input-label">Все статусы</div>
                  <v-autocomplete
                    dense
                    outlined
                  ></v-autocomplete>
                </div>
              </div>
            </v-form>
          </v-card-text>

          <div class="equipment-body--table--header">
            <div class="td1">Номер счета</div>
            <div class="td2">Дата создания</div>
            <div class="td3">Дата обновления</div>
            <div class="td4">Бонусы</div>
            <div class="td5">Статус</div>
            <div class="td6">Действие</div>
          </div>

          <div class="equipment-body--table--point">
            <div class="equipment-body--table--point-td td1">
              <span class="mob-title show-767">Номер:</span>
              <span>123312</span>
            </div>
            <div class="equipment-body--table--point-td td2">
              <span class="mob-title show-767">Создано:</span>
              <span>03.12.2022</span>
            </div>
            <div class="equipment-body--table--point-td td3">
              <span class="mob-title show-767">Изменено:</span>
              <span>03.12.2022</span>
            </div>
            <div class="equipment-body--table--point-td td4">
              <span class="mob-title show-767">Бонусы:</span>
              <span>1000</span>
            </div>
            <div class="equipment-body--table--point-td td5">
              <v-chip small class="sale-status status-green">
                Проверено
              </v-chip>
            </div>
            <div class="equipment-body--table--point-td td6 ico-redact">
              <v-btn
                fab
                small
                depressed
                color="transparent"
              >
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8063 8.69216L10.7294 5.61523" stroke="#8F95B2" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.03707 14.4606L4.19092 15.2299L4.96015 11.3837L12.6525 3.69141L15.7294 6.76833L8.03707 14.4606V14.4606Z" stroke="#8F95B2" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </v-btn>
            </div>
          </div>
          <div class="equipment-body--table--point">
            <div class="equipment-body--table--point-td td1">
              <span class="mob-title show-767">Номер:</span>
              <span>123312</span>
            </div>
            <div class="equipment-body--table--point-td td2">
              <span class="mob-title show-767">Создано:</span>
              <span>03.12.2022</span>
            </div>
            <div class="equipment-body--table--point-td td3">
              <span class="mob-title show-767">Изменено:</span>
              <span>03.12.2022</span>
            </div>
            <div class="equipment-body--table--point-td td4">
              <span class="mob-title show-767">Бонусы:</span>
              <span>1000</span>
            </div>
            <div class="equipment-body--table--point-td td5">
              <v-chip small class="sale-status status-orange">
                Ожидает проверки
              </v-chip>
            </div>
            <div class="equipment-body--table--point-td td6 ico-redact">
              <v-btn
                fab
                small
                depressed
                color="transparent"
              >
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8063 8.69216L10.7294 5.61523" stroke="#8F95B2" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.03707 14.4606L4.19092 15.2299L4.96015 11.3837L12.6525 3.69141L15.7294 6.76833L8.03707 14.4606V14.4606Z" stroke="#8F95B2" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </v-btn>
            </div>
          </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page7',
  data() {
    return {
      activePicker: null,
      menu: false,
      dateInstallation: null,
      type: 'installation',
      menu1: false,
      menu2: false,
      activePicker1: null,
      activePicker2: null,
      dateInstallation1: null,
      dateInstallation2: null,
    };
  },
  computed: {
    computedDateFormatted1() {
      return this.FormatDate(this.dateInstallation1);
    },
    computedDateFormatted2() {
      return this.FormatDate(this.dateInstallation2);
    },
    loading() {
      return this.$store.state.loading;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    salesTypical() {
      return this.$store.state.sales.salesTypical;
    },
    salesTicket() {
      return this.$store.state.sales.salesTicket;
    },
  },
  watch: {
    /** Вотчер для даты */
    menu(val) {
      // eslint-disable-next-line no-return-assign
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    /** Записать дату */
    SaveDate1(date) {
      this.$refs.menu1.save(date);
    },
    SaveDate2(date) {
      this.$refs.menu2.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
};
</script>

<style lang="scss" scoped src="./style.scss"/>
